import api from './api';

export const authService = {
  async register(name, email, password, avatar) {
    const response = await api.post('/register', {
      name,
      email,
      password,
      password_confirmation: password,
      avatar,
    });
    if (response.data.token) {
      localStorage.setItem('token', response.data.token);
    }
    return response.data;
  },

  async login(email, password) {
    const response = await api.post('/login', { email, password });
    if (response.data.token) {
      localStorage.setItem('token', response.data.token);
    }
    return response.data;
  },

  async logout() {
    await api.post('/logout');
    localStorage.removeItem('token');
  },

  async getCurrentUser() {
    const response = await api.get('/me');
    return response.data.user;
  },

  async updateProfile(data) {
    const response = await api.put('/user/profile', data);
    return response.data.user;
  },
};
